(() => {
  const init = (nav) => {
    if (nav.dataset.serviceNavReady === 'true') return;
    nav.dataset.serviceNavReady = 'true';

    const introSection = nav.closest('.shopify-section');
    if (!introSection) return;

    const headings = [...document.querySelectorAll('.shopify-section h2')]
      .filter((heading) => {
        const section = heading.closest('.shopify-section');
        return section && section.compareDocumentPosition(introSection) & Node.DOCUMENT_POSITION_PRECEDING;
      })
      .filter((heading) => !heading.closest('.site-footer'))
      .slice(0, 7);

    if (headings.length < 2) return;

    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `ll-service-section-${index + 1}`;
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      nav.appendChild(link);
    });

    nav.hidden = false;
  };

  const initAll = () => document.querySelectorAll('[data-ll-service-page-nav]').forEach(init);
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
